import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import moment from 'moment';
import { find, cloneDeep, get, capitalize, map, isEqual, startCase } from 'lodash';
import store from '../../helpers/store'
import ReactSelect from '../../components/common/ReactSelect';
import SearchWidget from '../../components/pages/home/SearchWidget';
import FilterList from '../../components/widgets/entityFilter/FilterList';
import Datepicker from '../../components/common/Datepicker';
import EntityFilter from '../../components/widgets/entityFilter/EntityFilter';
import CSVImportModal from '../../components/common/CSVImportModal';
import CSVSampleDownload from '../../components/common/CSVSampleDownload';
import Multiselect from '../../components/common/Multiselect/Multiselect';
import FieldMapper from '../../components/widgets/entityFilter/FieldMapper';
import Spinner from '../../components/common/Spinner';
import MatchMediaWrapper from '../../helpers/MatchMediaWrapper';
import FieldSelector from '../../components/common/Datagrid/FieldsSelector';
import Calendar from '../../components/pages/mailingLists/Calendar';
import { imprintsActions } from '../../data/actions/imprints';
import { artistsActions } from '../../data/actions/artists';
import { productsActions } from '../../data/actions/products';
import { projectsActions } from '../../data/actions/projects';
import { tracksActions } from '../../data/actions/tracks';
import { userEntityFiltersActions } from '../../data/actions/user_entity_filters';
import { imprintsSettings } from '../../components/pages/imprints/Settings';
import { artistsSettings } from '../../components/pages/artists/Settings';
import { projectsSettings } from '../../components/pages/projects/Settings';
import { productsSettings } from '../../components/pages/products/Settings';
import { tracksSettings } from '../../components/pages/tracks/Settings';
const allEntityTypes = ['imprints', 'artists', 'products', 'projects', 'tracks'];
import durations from './durations.json';
import vendors from '../../components/widgets/filter/enums/vendors.json';
import content_types from '../../components/widgets/filter/enums/content_types.json';
import ranges from '../../components/widgets/filter/enums/ranges.json';
import countries from '../../data/countries_data.json';
import { catalogMailingListsActions } from '../../data/actions/catalog_mailing_lists';
import { mailingListsFormatter } from '../../data/formatters/mailing_lists';
import demo from './demo';
import { Helmet } from 'react-helmet';
import UserFieldSelector from '../../components/common/Datagrid/UserFieldsSelector';
import NextRun from '../../components/pages/mailingLists/NextRun';
import { ordinalSuffix } from '../../helpers/NumberFormatter';
import vendorFieldsBuilder from './fields';

const fieldsSettings = {
	imprints: imprintsSettings,
	artists: artistsSettings,
	projects: projectsSettings,
	products: productsSettings,
	tracks: tracksSettings
};

const fmt = "YYYY-MM-DD";

const deleteSvg = require('!svg-inline-loader!../../../public/img/icons/delete.svg');
const editSvg = require('!svg-inline-loader!../../../public/img/icons/edit.svg');

const globalFilterList = [
	//"limit",
	"range",
	"active",
	"genres",
	//"dateEnd",
	"sources",
	"vendors",
	//"dateStart",
	"firstDays",
	//"forcePrev",
	// "filteredBy",
	"releaseEnd",
	"contentType",
	//"prevDateEnd",
	"territories",
	"audioFormats",
	"releaseStart",
	//"prevDateStart",
	"completeVendors",
	"incompleteVendorsList"
]


class CatalogReportDetails extends React.Component {

	constructor(props){
		super(props);
		this.state = {
			baseEntity: null,
			report_name: '',
			filter_id: null,
			user_filter_id: null,
			duration: durations[0].value,
			sorted: [{id: 'curr_units', desc: true}],
			fields: [],
			vendorFields: [],
			globalFilter: {},
			entityFilter: [],
			schedule_type: 'daily',
			skip_weekend: false,
			// true immediately for new reports; stays false for edits until
			// loadMailingList() completes, so Calendar doesn't mount with stale defaults
			calendarReady: false,
			errors: {},
			submitted: false,
			custom_email_subject: '',
			custom_email_body: '',  
			delay_days: 2
		}
		this.setFilterValue = this.setFilterValue.bind(this);
		this.setDateRanges = this.setDateRanges.bind(this);
		this.setFields = this.setFields.bind(this);
		this.setGlobalFilter = this.setGlobalFilter.bind(this);
		this.setEntityFilter = this.setEntityFilter.bind(this);
		this.setCustomDate = this.setCustomDate.bind(this);
		this.setDelay = this.setDelay.bind(this);
	}
	
	componentDidMount(){
		const { match, dispatch } = this.props; 
		const { id, entity } = match.params;
		const { duration } = this.state;
		dispatch(userEntityFiltersActions.getUserEntityFilters(true)).then(()=>{
			if(id !== 'new') {
				dispatch(catalogMailingListsActions.getCatalogMailingListDetails(id)).then(mailingList=>{
					this.loadMailingList(mailingList, id)
				});
			} else {
				this.setDateRanges(duration, ()=>{
					this.setState({ 
						calendarReady: true,
						filter_id: 0,
						user_filter_id: 0,
						baseEntity: (entity ? entity : null)
					});
				})
			}
		})
	}
	
	loadMailingList(mailingList){
		const globalFilters = get(this.props, 'filter.data', []);
		const entityFilters = get(this.props, 'userEntityFilters.filters', []);
		const globalFilter = get(find(globalFilters, f=>f.id == mailingList.filter_id), 'filter_body', []);
		const entityFilter = get(find(entityFilters, f=>f.id == mailingList.user_filter_id), 'entities', []);
		this.setState({
			...this.state,
			...mailingList,
			globalFilter,
			entityFilter,
			calendarReady: true,
		}, ()=>{
			
		})
	}
	
	componentWillReceiveProps(nextProps){
		const { match, dispatch } = nextProps; 
		const { id } = match.params;
		const { match: currentMatch } = this.props;
		const currentId = currentMatch.params.id;
		if(currentId && id != currentId) {
		}
		
	}
	
	setFilterValue(v, k){
		this.setState(prevState => ({
			[k]: v,
			errors: { ...prevState.errors, [k]: null },
		}))
	}
	
	setCustomDate(date, field){
		date = moment(date).format(fmt);
		
		this.setState({
			...this.state, 
			globalFilter: {
				...this.state.globalFilter,
				[field]: date
			}
		})
	}
	
	setDateRanges(duration, cb) {
	  const { delay_days } = this.state;	
	  const numberOfDays = find(durations, d=>d.value == duration).days;
	  const date_end       = moment().subtract(delay_days, "days");
	  const date_start     = date_end.clone().subtract(numberOfDays, "days");
	  const prev_date_end  = date_start.clone().subtract(1, "day");
	  const prev_date_start = prev_date_end.clone().subtract(numberOfDays, "days");
	
	  this.setState({
		 ...this.state, 
		duration, 
		globalFilter: {
			...this.state.globalFilter,
			dateEnd:        date_end.format(fmt),
			dateStart:      date_start.format(fmt),
			prevDateEnd:   prev_date_end.format(fmt),
			prevDateStart: prev_date_start.format(fmt),
		}
	  }, ()=>{
		  if(cb !== undefined)
		  	return cb();
	  });
	}
	
	setDelay(delay_days) {
		this.setState({delay_days}, ()=>{
			this.setDateRanges(this.state.duration);
		})
	}
	
	setFields(fields){
		const flatColumns = fields.filter(f=>!f.includes('.'));
		const vendorColumns = vendorFieldsBuilder(fields.filter(f=>f.includes('.')));
		this.setState(prevState => ({
        fields: flatColumns,
        vendorFields: vendorColumns,
        errors: { 
            ...prevState.errors, 
            fields: flatColumns.length === 0 ? prevState.errors.fields : null 
        },
    }))
	}
	
	setGlobalFilter(f){
		this.setState(prevState => ({
			filter_id: f.value,
			globalFilter: f.body,
			errors: { ...prevState.errors, filter_id: null },
		}))
	}
	
	setEntityFilter(f){
		this.setState(prevState => ({
			user_filter_id: f.value,
			entityFilter: f.body,
			errors: { ...prevState.errors, user_filter_id: null },
		}))
	}
	
	setCalendar = (calendar) => {
		let value = mailingListsFormatter.formatCalendar(calendar);
		const schedule_label = this.formatScheduleLabel(calendar);
		
		let { duration } = this.state;
		if(calendar.period == 'one_time')
			duration = 'one_time_range';
		
		this.setState(prevState => ({
			duration,
			start_date: calendar.date,
			schedule_type: calendar.period,
			schedule_value: value,
			schedule_label,
			skip_weekend: calendar.skipWeekend,
			errors: { ...prevState.errors, schedule_type: null },
		}))
	}

	formatScheduleLabel(calendar) {
		if(!calendar) return '';
		switch(calendar.period) {
			case 'one_time':
				return 'One Time';
			case 'daily':
				return 'Daily';
			case 'weekly':
				return `Weekly on ${calendar.dayOfWeek}`;
			case 'bi_weekly':
				return `Every 2nd week on ${calendar.dayOfWeek}`;
			case 'monthly_day':
				return `Monthly on ${ordinalSuffix(calendar.dayOfMonth)}`;
			case 'monthly_day_of_week':
				return `Monthly on every ${ordinalSuffix(calendar.weekOfMonth)} ${calendar.dayOfWeek}`;
			default:
				return '';
		}
	}

	validate(){
		const { baseEntity, filter_id, user_filter_id, duration, fields, schedule_type, report_name } = this.state;
		const errors = {};
		if(!baseEntity)
			errors.baseEntity = 'Please select a base entity type.';
//		if(!filter_id)
//			errors.filter_id = 'Please select a global filter.';
//		if(!user_filter_id)
//			errors.user_filter_id = 'Please select an entity filter.';
		if(!duration)
			errors.duration = 'Please select a date range.';
		if(!fields || fields.length === 0)
			errors.fields = 'Please select at least one field.';
		if(!schedule_type)
			errors.schedule_type = 'Please configure a schedule.';
		if(!report_name)
			errors.report_name = 'Please name your report.';
			
		return errors;
	}

	save(){
		const errors = this.validate();
		const hasErrors = Object.keys(errors).length > 0;
		this.setState({ submitted: true, errors });
		if(hasErrors)
			return;

		const { id } = this.state;
		return this.makeRequest(true).then(formattedParams=>{
			if(!isNaN(id)) {
				return this.props.dispatch(catalogMailingListsActions.editCatalogMailingList({
					...this.state,
				}, formattedParams, id))
			}
			else {
				return this.props.dispatch(catalogMailingListsActions.addCatalogMailingList({
					...this.state,
				}, formattedParams))
			}
		})
		.then(() => {
			this.props.history.push('/user/catalog-report');
		});

	}
	
	buildParams(){
		
		let { entityFilter, sorted } = this.state;
		const filteredArray = Object.entries(
			entityFilter.reduce((acc, { entity_type, entity_id }) => {
				if (!acc.hasOwnProperty(entity_type))
					acc[entity_type] = [];
				acc[entity_type].push(entity_id);
				return acc;
			}, {})
		).map(([id, value]) => ({ id, value }));
		filteredArray.push({ id: 'result', value: 'sql' });
		
		return {
			page: 1,
			sorted: sorted,
			filtered: filteredArray
		}
	}
	
	setData(){
		this.setState({
			...demo
		})
	}
	
	makeRequest(returnParams = false){
		const { dispatch } = this.props;
		const { baseEntity, globalFilter, fields, vendorFields } = this.state;
		const params = this.buildParams();
		switch(baseEntity) {
			case 'tracks':
				return dispatch(tracksActions.getAllTracks(params, globalFilter, fields, vendorFields, returnParams));
				break;
			case 'artists':
				return dispatch(artistsActions.getAllArtists(params, globalFilter, fields, vendorFields, returnParams));
				break;
			case 'products':
				return dispatch(productsActions.getAllProducts(params, globalFilter, fields, vendorFields, returnParams));
				break;
			case 'projects':
				return dispatch(projectsActions.getAllProjects(params, globalFilter, fields, vendorFields, returnParams));
				break;
			case 'imprints':
				return dispatch(imprintsActions.getAllImprints(params, globalFilter, fields, vendorFields, returnParams));
				break;
		}
	}
	
	formatTitle(str) {
		return startCase(str);
	}

	formatGlobalFilterValue(key, value) {
		if (value === null || value === undefined) return '';
		const values = Array.isArray(value) ? value : [value];
		const mapped = values.map(v => {
			if (v === null || v === undefined) return '';
			// Vendors
			if (['vendors', 'completeVendors', 'incompleteVendorsList'].includes(key)) {
				const found = find(vendors, ven => ven.vend_id == v || String(ven.vend_id) === String(v) || (ven.value && ven.value == v) || (ven.label && String(ven.label).toLowerCase() === String(v).toLowerCase()));
				return found ? found.label : v;
			}
			// Range mapping
			if (key === 'range') {
				const found = find(ranges, r => r.value == v || String(r.value).toLowerCase() === String(v).toLowerCase());
				return found ? found.label : v;
			}
			// Content types
			if (['contentType', 'content_type'].includes(key)) {
				const found = find(content_types, ct => ct.value == v || String(ct.value) === String(v) || (ct.label && String(ct.label).toLowerCase() === String(v).toLowerCase()));
				return found ? found.label : v;
			}
			// Territories / countries — match keys used in countries_data.json
			if (['territories', 'territory', 'country', 'countries'].includes(key)) {
				const lowered = String(v).toLowerCase();
				const found = find(countries, c => {
					if (!c) return false;
					const name = (c.name || '').toLowerCase();
					const a2 = (c['alpha-2'] || '').toLowerCase();
					const a3 = (c['alpha-3'] || '').toLowerCase();
					const cc = (c['country-code'] || '').toLowerCase();
					return lowered === name || lowered === a2 || lowered === a3 || lowered === cc;
				});
				return found ? found.name : v;
			}
			return v;
		});
		return mapped.filter(Boolean).join(', ');
	}
	
	renderBaseEntity(){
		const elements = allEntityTypes.map(e=>({
			label: capitalize(e),
			value: e
		}));
		const { baseEntity: selected, errors } = this.state;
		return <div className="base-entity-type">
			<h4>Base Entity Type</h4>
			<Multiselect elements={elements} selected={selected} handleChange={v=>this.setFilterValue(v, 'baseEntity')} />
			{errors.baseEntity && <span className="validation-error">{errors.baseEntity}</span>}
		</div>
	}
	
	renderName(){
		const { report_name, errors } = this.state;
		return <div className="base-entity-type">
			<h4>Name</h4>
			<input type="text" placeholder="Name your report" value={report_name} className="catalog-report-name" onChange={(e)=>this.setFilterValue(e.target.value, 'report_name')} />
			{errors.report_name && <span className="validation-error">{errors.report_name}</span>}
		</div>
	}
	
	renderDurations(){
		const { duration: selected, errors } = this.state;
		const elements = durations;
		return <div>
			<h4>Date Range</h4>
			<Multiselect elements={elements} selected={selected} handleChange={v=>this.setDateRanges(v)} />
			{errors.duration && <span className="validation-error">{errors.duration}</span>}
		</div>
	}
	
	renderDateRange(){
		const { globalFilter } = this.state;
		return <div>
			<h4>Custom Date Range</h4>
				<div className="daterange-item">
				  <div className="daterange-container">
				  <Datepicker date={globalFilter.dateStart} label="From" dateChange={(date)=>this.setCustomDate(date, 'dateStart')} placeholder="Start Date" showYearDropdown selectsStart={true} monthsShown={1}  />
				  <span className='fas fa-long-arrow-alt-right'></span>
				  <Datepicker date={globalFilter.dateEnd} label="To" dateChange={(date)=>this.setCustomDate(date, 'dateEnd')} placeholder="End Date" className="form-control text-right" showYearDropdown selectsStart={true} monthsShown={1}   />
			  </div>
			</div>
		</div>
	}

	
	renderAdvanced(){
		const { delay_days, custom_email_body, custom_email_subject } = this.state;
		return <div>
			<h4>Advanced</h4>
			<div className="catalog-report-advanced-item">
				<label for="delay_days">Delay days</label>
				<input id="delay_days" type="number" value={delay_days} className='form-control' onChange={(e)=>this.setDelay(e.target.value, 'delay_days')} />
			</div>
			<div className="catalog-report-advanced-item long">
				<label for="custom_subject">Custom Email Subject</label>
				<input id="custom_subject" type="text" value={custom_email_subject} className='form-control' onChange={(e)=>this.setFilterValue(e.target.value, 'custom_email_subject')} />
			</div>
			<div className="catalog-report-advanced-item long">
				<label for="custom_body">Custom Email Body</label>
				<textarea id="custom_body" rows="2" value={custom_email_body} className='form-control' onChange={(e)=>this.setFilterValue(e.target.value, 'custom_email_body')} />
			</div>


	
		</div>
	}
	
	renderFieldSelector(baseEntity){
    const { fields, vendorFields, errors } = this.state;
    if(!baseEntity) return null;

    const settings = fieldsSettings[baseEntity].settingsForTable(fields);

    const selectedVendorFieldIds = settings
        .filter(field => field.id && field.id.includes('.'))
        .filter(field => {
            const columnName = field.id
                .split('.')
                .map(n => n.replace(/[ -]+/g, '_'))
                .join('_');

            return vendorFields.some(vf => vf.column_name === columnName);
        })
        .map(field => field.id);

    const selectedColumns = [...fields, ...selectedVendorFieldIds];

    const hasFieldsSelected = selectedColumns.length > 0;

    return <div>
        <UserFieldSelector
            key={baseEntity}
            settings={settings}
            current={{ columns: selectedColumns }}
            onUpdate={v => this.setFields(v.columns)}
            extraClassName="catalog-report-selector"
            sortableColumns={true}
        />

        {errors.fields && !hasFieldsSelected && (
            <span className="validation-error">{errors.fields}</span>
        )}
    </div>
	}
	
	renderGlobalFilters(){
		const { filter_id, globalFilter, errors } = this.state;
		const savedFilters = get(this.props, 'filter.data', []);
		let mapSavedFilters = savedFilters.map(filter => ({
			label: filter.filter_name, 
			value: filter.id, 
			user_id: filter.user_id, 
			is_shared: filter.is_shared, 
			body: filter.filter_body
		}));
		
		mapSavedFilters.unshift({
			label: '---default---', 
			value: 0, 
			user_id: get(this.props, 'user.user.id'), 
			is_shared: false, 
			body: {}
		})
		
		const selectedOption = find(mapSavedFilters, filter=>isEqual(filter.value, filter_id))
		const visibleKeys = Object.keys(globalFilter).filter(key => 
        globalFilterList.includes(key)
    );

		return <div className="report-global-filter">
			<div className="report-global-filter-item">
				<h4>Global Filter</h4>
				<div>
					<ReactSelect options={mapSavedFilters} placeholder="Choose Global Filter" onChange={v=>this.setGlobalFilter(v)} value={selectedOption} className="select-wrapper" />
					{errors.filter_id && <span className="validation-error">{errors.filter_id}</span>}
				</div>
			</div>
			<div className="report-global-filter-item">
				<h4>Global Filter Preview</h4>
				<ul className="global-filter-preview-list">
					{visibleKeys.sort().map(f => {
						const value = globalFilter[f];
						
						if(!value || typeof value == 'object' && (!Array.isArray(value) || value.length == 0))
							return null; // handle invalid saved filters with nested props
						return <li key={f} className="global-filter-preview-item"><span className="global-filter-preview-item-title">{this.formatTitle(f)}:</span> <span className="global-filter-preview-item-value">{this.formatGlobalFilterValue(f, value)}</span></li>
					})}
				</ul>
			</div>
		</div>
	}
	
	renderEntityFilters(){
		const { user_filter_id, entityFilter, errors } = this.state;
		const savedFilters = get(this.props, 'userEntityFilters.filters', []);
		const mapSavedFilters = savedFilters.map(filter => ({label: filter.caption, value: filter.id, user_id: filter.user_id, is_shared: filter.is_shared, body: filter.entities}));
		mapSavedFilters.unshift({
			label: '---default---', 
			value: 0, 
			user_id: get(this.props, 'user.user.id'), 
			is_shared: false, 
			body: []
		})
		const selectedOption = find(mapSavedFilters, filter=>isEqual(filter.value, user_filter_id));
		const groupedEntities = entityFilter.reduce((acc, entity) => {
			const type = entity.entity_type;
			if (!acc[type]) {
				acc[type] = [];
			}
			acc[type].push(entity);
			return acc;
		}, {});

		return <div className="report-global-filter">
			<div className="report-global-filter-item">
				<h4>Saved Entity Filter</h4>
				<div>
					<ReactSelect options={mapSavedFilters} placeholder="Choose Entity Filter" onChange={v=>this.setEntityFilter(v)} value={selectedOption} className="select-wrapper" />
					{errors.user_filter_id && <span className="validation-error">{errors.user_filter_id}</span>}
				</div>
			</div>
			<div className="report-global-filter-item">
				<h4>Saved Filter Preview</h4>
				<ul className="global-filter-preview-list">
					{Object.entries(groupedEntities).map(([type, entities]) => (
						<li key={type} className="global-filter-preview-item">
							<span className="global-filter-preview-item-title entity-type">{type}:</span>{' '}
							<span className="global-filter-preview-item-value">{entities.map(e => e.entity_title).join(', ')}</span>
						</li>
					))}
				</ul>
			</div>
		</div>
	}
	
	renderCalendar(){
		const { calendarReady, errors } = this.state;
		const mailingList = this.state;
		return <div className='catalog-report-schedule'>
			<div className="catalog-report-schedule-holder">
				<div className="catalog-report-schedule-item">
					<h4>Task Execution</h4>
					<div className="catalog-report-schedule-note">
						<strong>Note</strong> reports are sent at 04:00 AM server time. Daily/Custom schedules start the day after creation. Weekly/Monthly schedules start from the creation date.
					</div>
					<div>
						{calendarReady && <Calendar mailingList={mailingList} onChange={this.setCalendar} showNextRun={false} isInline={false}  />}
						{errors.schedule_type && <span className="validation-error">{errors.schedule_type}</span>}
					</div>
				</div>
				<div className="catalog-report-schedule-item">
					<h4>Schedule Preview</h4>
					<ul className='global-filter-preview-list'>
						<li className='global-filter-preview-item'>
							{calendarReady && (
								<NextRun 
									period={this.state.schedule_type}
									date={this.state.start_date}
									skipWeekend={this.state.skip_weekend}
								/>
							)}
						</li>
						<li className='global-filter-preview-item'>
							<span className="global-filter-preview-item-title">Selected Schedule: </span>
							<span className="global-filter-preview-item-value">{calendarReady && this.state.schedule_label}</span>
						</li>
						<li className='global-filter-preview-item'>
							<span className="global-filter-preview-item-title">Report Dates: </span>
							<span className="global-filter-preview-item-value">{this.state.globalFilter.dateStart} - {this.state.globalFilter.dateEnd}</span>
						</li>
						<li className='global-filter-preview-item'>
							<span className="global-filter-preview-item-title">Sending Time: </span>
							<span className="global-filter-preview-item-value">04:00 AM (Server Time)</span>
						</li>
					</ul>
				</div>
			</div>
		</div>
	}

	
	render() {
		const { baseEntity, id, duration } = this.state;
		const mainButtonLabel = isNaN(id) ? 'Create' : 'Update';
		return (
			<div className="inner-page shared-pages catalog-report-page">
				<div className="ibox">
					<div className="catalog-report-title-holder">
						<h2 className="saved-filter-title">Create Custom Report</h2>
						<div className="catalog-report-warning">
							Access to full catalog reports is available on request. Contact your administrator for access.
						</div>
					</div>
					<div className="user-entity-filter-holder create-filter">
						{this.renderName()} 
						{this.renderBaseEntity()} 
						{duration != 'one_time_range' && this.renderDurations()} 
						{duration == 'one_time_range' && this.renderDateRange()} 
						{this.renderFieldSelector(baseEntity)}
						{this.renderGlobalFilters()} 
						{this.renderEntityFilters()}
						{this.renderCalendar()}
						{this.renderAdvanced()}
						<div className="buttons-holder catalog-report-buttons-holder">
							<button className="default-btn default-btn--small" onClick={()=>this.makeRequest()}>Run Now</button>
							<button className="default-btn default-btn--small" onClick={()=>this.save()}>{mainButtonLabel}</button>
							{this.state.submitted && Object.keys(this.state.errors).length > 0 && (
								<div className="validation-summary">
									Please fix the errors above before saving.
								</div>
							)}
						</div>
					</div>   
				</div>
				<Helmet>
					<title>Create Custom Report</title>
				</Helmet>
			</div>
			
		)
	}
}

function mapStateToProps(state) {
	return {
		filter: state.filter,
		userEntityFilters: state.userEntityFilters
	} 
}
export default connect(mapStateToProps)(withRouter(CatalogReportDetails));